<template>
  <div
    class="page_container addEditBrandIncreasePage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/supplierIndex/supplierList' }"
          >合作&自有｜生产商管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>合作&自有｜生产商管理设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>合作品牌管理设置</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>供应商名称：</p>
            <div class="input_box">
              <el-input
                v-model="formData.labelname"
                placeholder="请输入供应商名称"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>供应商状态：</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.labelstate"
                style="justify-content: space-evenly"
              >
                <el-radio label="1">启用</el-radio>
                <el-radio
                  label="0"
                  :disabled="id != '' ? true : false"
                  checked-color="#ee0a24"
                  >停用
                </el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>
  
  <script>
import {
  getSupplierDetail,
  addSupplier,
  editSupplier,
  encryptstringview,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "supplierDetail",
  data() {
    return {
      formData: {
        openid: "",
        qyid: "",
        labelname: "",
        labelcont: "",
        sort: "",
        labelstate: "1",
        linkurl: "",
        apppath: "",
        createman: "",
      },
      id: "",
      loading: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.formData.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.formData.createman = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;
    this.formData.openid = USERINFO.openid;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if(routerList[name].encryptstring == '') return
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 初始化数据
    init(id) {
      getSupplierDetail({ id }).then((res) => {
        this.formData.labelname = res.labelname;
        this.formData.labelcont = res.labelcont;
        this.formData.sort = res.sort ? res.sort : "";
        this.formData.labelstate = res.labelstate ? res.labelstate : 0;
        this.formData.linkurl = res.linkurl;
        this.formData.apppath = res.apppath;
      });
    },

    // 提交编辑数据
    query() {
      let { formData, id } = this;
      if (formData.labelname == "") {
        this.$message.warning("请输入供应商名称");
        return;
      }
      // if (formData.labelcont == "") {
      //   this.$toast("请输入标签内容");
      //   return;
      // }
      if (formData.labelstate == "") {
        this.$message.warning("请选择供应商状态");
        return;
      }
      formData.labelcont = formData.labelname;
      if (id == "") {
        this.loading = true;
        addSupplier(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   // this.clearData();
            //   this.handleReturn();
            // }, 1000);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.$message.error(res.message);
            this.clearData();
          }
        });
      } else {
        formData.id = id;
        this.loading = true;
        editSupplier(formData).then((res) => {
          if (res.result) {
            // this.$toast.success(res.message);
            // setTimeout(() => {
            //   this.handleReturn();
            // }, 2000);
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    // 清空
    clearData() {
      this.formData.labelname = "";
      this.formData.labelcont = "";
      this.formData.sort = "";
      this.formData.labelstate = "";
      this.formData.linkurl = "";
      this.formData.apppath = "";
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
  <style lang="less" scoped>
.addEditBrandIncreasePage {
}
</style>